import { Product } from "@1games-ru/region-shared/dist/backend/requests/shop";
import clsx from "clsx";
import Button from "@/shared/ui/button/Button";
import { NavItemType } from "@/domains/shop/constants/navItemType";
import { tabIconsList } from "@/domains/shop/helpers/tabIconsList";

type Props = {
  navList: NavItemType[];
  isCart: boolean;
  setIsCart: (value: boolean) => void;
  setNavList: (value: NavItemType[]) => void;
  setSelectedGoods: (value: Product[]) => void;
  goodsList: Product[];
};

export default function ShopAsideNav({
  navList,
  isCart,
  setIsCart,
  setNavList,
  setSelectedGoods,
  goodsList,
}: Props) {
  const handleClick = (btnText: string) => {
    if (isCart) setIsCart(false);
    let activeEl = "";
    setNavList(
      navList.map((item) => {
        if (item.text === btnText) activeEl = item.id;
        return { ...item, isActive: item.text === btnText };
      }),
    );
    if (activeEl === "all") {
      setSelectedGoods(goodsList);
    } else {
      setSelectedGoods(goodsList.filter((item) => item.category === activeEl));
    }
  };

  return (
    <div className="flex flex-col gap-1.5">
      {navList.map((item) => {
        const IconComponent = tabIconsList[item.id];

        return (
          <Button
            key={item.text}
            className={clsx(
              "group justify-start gap-2.5 h-11 leading-none",
              item.isActive && "pointer-events-none",
            )}
            onClick={() => handleClick(item.text)}
            variant={item.isActive ? "solid-gradient" : "soft"}
            color={item.isActive ? "accent" : "gray"}
          >
            {IconComponent && (
              <IconComponent
                className={clsx(
                  "text-white/50 transition-colors duration-200",
                  !item.isActive && "group-hover:text-accent-solid",
                )}
                style={{ color: `${item.isActive ? "#FFFFFF" : ""}`, width: "1.1rem" }}
              />
            )}
            {item.text}
          </Button>
        );
      })}
    </div>
  );
}
